import { render, staticRenderFns } from "./OrderDetailsButton.vue?vue&type=template&id=2730f386&"
import script from "./OrderDetailsButton.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports